import "esbuild-css-modules-plugin-ns-css:src/ui/UIField.module.css";

export default {
  "actionField": "UIField-module__action-field_lh-KDa__0230",
  "label": "UIField-module__label_lh-KDa__0230",
  "labelFocused": "UIField-module__label-focused_lh-KDa__0230",
  "selectInput": "UIField-module__select-input_lh-KDa__0230",
  "submitButton": "UIField-module__submit-button_lh-KDa__0230",
  "textInput": "UIField-module__text-input_lh-KDa__0230",
  "uiField": "UIField-module__ui-field_lh-KDa__0230"
};
      